/* eslint-disable react/destructuring-assignment */
import React from 'react';
import CX from 'classnames';
import PropTypes from 'prop-types';

import createUuid from '../../../javascripts/helpers/createUuid';

export default class SvgSprite extends React.Component {
  renderContent(titleId, descId) {
    if (this.props.title) {
      return <title id={titleId}>{this.props.title}</title>;
    }
    if (this.props.desc) {
      return <desc id={descId}>{this.props.desc}</desc>;
    }
    return null;
  }

  render() {
    const classes = CX('a-svg-sprite', `a-svg-sprite--${this.props.id}`, this.props.className);

    const uuid = createUuid();
    const titleId = `title-${this.props.id}-${uuid}`;
    const descId = `desc-${this.props.id}-${uuid}`;

    const svgProps = {
      className: classes,
      role: 'img',
      'data-js-module': 'a-svg-sprite',
      ...this.props.attributes
    };

    if (this.props.title) {
      svgProps['aria-labelledby'] = titleId;
    } else if (this.props.desc) {
      svgProps['aria-labelledby'] = descId;
    }

    return (
      <svg {...svgProps}>
        {this.renderContent(titleId, descId)}
        <use xlinkHref={`#${this.props.id}`} />
      </svg>
    );
  }
}

SvgSprite.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  attributes: PropTypes.objectOf(PropTypes.bool)
};

SvgSprite.defaultProps = {
  className: '',
  title: null,
  desc: null,
  attributes: {}
};
